export default __webpack_public_path__ + "static/media/4.24e90923.png";